import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-youtube",
  "use": "icon-youtube-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-youtube\"><title>icon-youtube</title><path d=\"M370.667 111.87c-56.162-3.834-181.25-3.819-237.334 0C72.605 116.013 65.452 152.696 65 249.25c.452 96.382 7.542 133.22 68.333 137.38 56.1 3.819 181.172 3.834 237.334 0 60.728-4.144 67.881-40.827 68.333-137.38-.452-96.382-7.542-133.22-68.333-137.38zM205.25 311.581V186.918l124.667 62.223-124.667 62.441z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol